export const GetDisciplineById = (personelid) => {

  return $.get('Personnel/GetDisciplineById?Id=' + personelid)

}
export const GetDisciplinedByUsers = (personelid) => {

  return $.get('Personnel/GetDisciplinedByUsers')

}

export const AddDiscipline = (model) => {
  return $.post('Personnel/AddDiscipline', model)
}
export const UpdateDiscipline = (model) => {
  return $.post('Personnel/UpdateDiscipline', model)
}
export const DeleteDiscipline = (DisciplineId) => {

  return $.post('Personnel/DeleteDiscipline?DisciplineId=' + DisciplineId)

}

export const GetDisciplinaryActions = () => {

  return $.get('Personnel/GetDisciplinaryActions?IsActive=' + true)

}



// WEBPACK FOOTER //
// ./src/components/discipline/discipline.service.js